import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {Page} from '../../../shared/models/page.interface';
import {Master} from '../../../admin/models/master.interface';
import {MatRadioChange} from '@angular/material/radio';
import {IdValue} from '../../../shared/models/id-value.interface';
import {ClassifierForm} from '../../../admin/models/classifier-form.interface';
import {ReportCycleDetail} from '../../../admin/models/report-cycle-detail';
import {MatStepper} from '@angular/material/stepper';
import {MatSelectChange} from '@angular/material/select';
import {ClassifierPageEvent} from '../../../admin/models/classifier-page-event.interface';
import {Router} from '@angular/router';

@Component({
  selector: 'app-kf-next-report-classifiers-wizard',
  templateUrl: './kf-next-report-classifiers-wizard.component.html',
  styleUrls: ['./kf-next-report-classifiers-wizard.component.scss']
})
export class KfNextReportClassifiersWizardComponent implements OnInit, OnChanges {

  @ViewChild('stepper')
  stepper!: MatStepper;

  @Input()
  reportCycle!: ReportCycleDetail;

  @Input()
  wizardStep!: number;

  @Input()
  UNUKeys!: Page<Master>;
  @Input()
  previousUnuKeySets?: IdValue[];

  @Output()
  loadUNUKeysPage: EventEmitter<ClassifierPageEvent> = new EventEmitter<ClassifierPageEvent>();
  @Output()
  loadPreviousUNUKeys: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  saveUNUKeyForm: EventEmitter<ClassifierForm> = new EventEmitter<ClassifierForm>();

  @Input()
  categories!: Page<Master>;
  @Input()
  previousCategoriesSets?: IdValue[];

  @Output()
  loadCategoriesPage: EventEmitter<ClassifierPageEvent> = new EventEmitter<ClassifierPageEvent>();
  @Output()
  loadPreviousCategories: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  saveCategoriesForm: EventEmitter<ClassifierForm> = new EventEmitter<ClassifierForm>();

  @Input()
  collectionStreams!: Page<Master>;
  @Input()
  previousCollectionStreamsSets?: IdValue[];

  @Output()
  loadCollectionStreamsPage: EventEmitter<ClassifierPageEvent> = new EventEmitter<ClassifierPageEvent>();
  @Output()
  loadPreviousCollectionStreams: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  saveCollectionStreamsForm: EventEmitter<ClassifierForm> = new EventEmitter<ClassifierForm>();

  @Output()
  loadWizardStep: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  loadWizardStep1: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  changeWizardStep: EventEmitter<number> = new EventEmitter<number>();

  unuKeysFormGroup!: FormGroup;
  categoriesForm!: FormGroup;
  collectionStreamsForm!: FormGroup;
  unuKeySelectedOption = 0;
  categoriesSelectedOption = 0;
  collectionStreamsSelectedOption = 0;

  constructor(private formBuilder: FormBuilder,
              private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.wizardStep?.previousValue !== changes?.wizardStep?.currentValue) {
      setTimeout(() => {
        this.stepper.linear = false;
        this.stepper.selectedIndex = this.wizardStep;
        this.stepper.linear = true;
      });
    }
  }


  ngOnInit(): void {
    this.unuKeysFormGroup = this.formBuilder.group({
      unuKeyOption: [undefined, Validators.required],
      setName: [this.reportCycle?.unuKeySetName || ''],
      previousSet: [{id: this.reportCycle?.previousUnuKeySetId}]
    }, {validators: this.checkSetSelected});
    this.categoriesForm = this.formBuilder.group({
      categoriesOption: [undefined, Validators.required],
      setName: [this.reportCycle?.kfCategorySetName],
      previousSet: [{id: this.reportCycle?.previousKfCategorySetId}]
    }, {validators: this.checkSetSelected});
    this.collectionStreamsForm = this.formBuilder.group({
      collectionStreamsOption: [undefined, Validators.required],
      setName: [this.reportCycle?.collectionStreamName],
      previousSet: [{id: this.reportCycle?.previousCollectionStreamId}]
    }, {validators: this.checkSetSelected});


    this.preloadData();

  }

  private preloadData(): void {

    if (this.reportCycle?.previousUnuKeySetId) {
      this.unuKeySelectedOption = 2;
      this.unuKeysFormGroup.controls.unuKeyOption.setValue(2);
      this.loadUNUKeysPage.emit(({pageRequest: {page: 0, size: 20}, schemaId: this.reportCycle?.previousUnuKeySetId}));
    } else if (this.reportCycle?.unuKeySetName) {
      this.unuKeySelectedOption = 1;
      this.unuKeysFormGroup.controls.unuKeyOption.setValue(1);
      this.loadUNUKeysPage.emit({pageRequest: {page: 0, size: 20}});
    }

    if (this.reportCycle?.previousKfCategorySetId) {
      this.categoriesSelectedOption = 2;
      this.categoriesForm.controls.categoriesOption.setValue(2);
      this.loadCategoriesPage.emit(({pageRequest: {page: 0, size: 20}, schemaId: this.reportCycle?.previousKfCategorySetId}));
    } else if (this.reportCycle?.kfCategorySetName) {
      this.categoriesSelectedOption = 1;
      this.categoriesForm.controls.categoriesOption.setValue(1);
      this.loadCategoriesPage.emit({pageRequest: {page: 0, size: 20}});
    }

    if (this.reportCycle?.previousCollectionStreamId) {
      this.collectionStreamsSelectedOption = 2;
      this.collectionStreamsForm.controls.collectionStreamsOption.setValue(2);
      this.loadCollectionStreamsPage.emit(({pageRequest: {page: 0, size: 20}, schemaId: this.reportCycle?.previousCollectionStreamId}));
    } else if (this.reportCycle?.collectionStreamName) {
      this.collectionStreamsForm.controls.collectionStreamsOption.setValue(1);
      this.collectionStreamsSelectedOption = 1;
      this.loadCollectionStreamsPage.emit({pageRequest: {page: 0, size: 20}});
    }
  }

  loadUNUKeys(event: PageRequest): void {
    this.loadUNUKeysPage.emit(({pageRequest: event, schemaId: this.unuKeysFormGroup.value.previousSet?.id}));
  }

  onUNUKeyOptionChange(event: MatRadioChange): void {
    this.unuKeySelectedOption = event.value;
    this.onOptionChange(event.value, this.unuKeysFormGroup);
    if (event.value === 1) {
      this.loadUNUKeysPage.emit({pageRequest: {page: 0, size: 5}});
    }
  }

  compareMasters(item1: Master, item2: Master): boolean {
    return (item1 && item2 && item1.id === item2.id);
  }

  submitUNUKeysForm(): void {
    this.saveUNUKeyForm.emit({
      option: this.unuKeySelectedOption,
      name: this.unuKeysFormGroup.value.setName,
      previousObject: this.unuKeysFormGroup.value.previousSet
    });
  }

  loadCategories(event: PageRequest): void {
    this.loadCategoriesPage.emit({pageRequest: event, schemaId: this.categoriesForm.value.previousSet?.id});
  }

  onCategoriesOptionChange(event: MatRadioChange): void {
    this.categoriesSelectedOption = event.value;
    this.onOptionChange(event.value, this.categoriesForm);
    this.loadCategoriesPage.emit({pageRequest: {page: 0, size: 5}});
  }


  submitCategoriesForm(): void {
    this.saveCategoriesForm.emit({
      option: this.categoriesSelectedOption,
      name: this.categoriesForm.value.setName,
      previousObject: this.categoriesForm.value.previousSet
    });
  }

  loadCollectionStreams(event: PageRequest): void {
    this.loadCollectionStreamsPage.emit({pageRequest: event, schemaId: this.collectionStreamsForm.value.previousSet?.id});
  }

  onCollectionStreamsOptionChange(event: MatRadioChange): void {
    this.collectionStreamsSelectedOption = event.value;
    this.onOptionChange(event.value, this.collectionStreamsForm);
    this.loadCollectionStreamsPage.emit({pageRequest: {page: 0, size: 5}});
  }

  submitCollectionStreamsForm(): void {
    this.saveCollectionStreamsForm.emit({
      option: this.collectionStreamsSelectedOption,
      name: this.collectionStreamsForm.value.setName,
      previousObject: this.collectionStreamsForm.value.previousSet
    });
  }

  private onOptionChange = (option: number, form: FormGroup) => {
    if (option === 3) {
      form?.controls?.setName?.reset();
      form?.controls?.previousSet?.reset();
    }
    if (option === 2) {
      form.controls.setName.reset();
      form.controls.previousSet.markAsDirty();
    }
    if (option === 1) {
      form.controls.previousSet.reset();
      form.controls.setName.markAsDirty();
    }
  }

  private checkSetSelected(control: AbstractControl): void {
    const setName = control.get('setName')?.value;
    const previousSet = control.get('previousSet')?.value;

    if (setName || previousSet?.id) {
      return;
    } else {
      if (control.get('setName')?.touched || control.get('setName')?.dirty) {
        control.get('setName')?.setErrors({noSetSelected: true});
      }
      if (control.get('previousSet')?.touched || control.get('previousSet')?.dirty) {
        control.get('previousSet')?.setErrors({noSetSelected: true});
      }
    }
  }


  goToStep(index: number): void {
    this.changeWizardStep.emit(index);
  }

  onUnuKeySetChange(event: MatSelectChange): void {
    this.loadUNUKeysPage.emit({pageRequest: {page: 0, size: 5}, schemaId: event.value.id});
  }

  onCategorySetChange(event: MatSelectChange): void {
    this.loadCategoriesPage.emit({pageRequest: {page: 0, size: 5}, schemaId: event.value.id});
  }

  onCollectionStreamSetChange(event: MatSelectChange): void {
    this.loadCollectionStreamsPage.emit({pageRequest: {page: 0, size: 5}, schemaId: event.value.id});
  }

  goBack(): void {
    this.loadWizardStep1.emit(1);
  }

  continue(): void {
    this.loadWizardStep.emit(3);
  }

  nextStep(): void {
    if (this.wizardStep === 0 && this.unuKeySelectedOption === 3) {
      this.router.navigateByUrl('/kfreporting/classifiers/unu-keys',
        {state: {origin: '/kfreporting/kfconfiguration/nextreportcycle', wizardStep: 0}});
    } else if (this.wizardStep === 1 && this.categoriesSelectedOption === 3) {
      this.router.navigateByUrl('/kfreporting/classifiers/kf-categories',
        {state: {origin: '/kfreporting/kfconfiguration/nextreportcycle', wizardStep: 1}});
    } else if (this.wizardStep === 2 && this.collectionStreamsSelectedOption === 3) {
      this.router.navigateByUrl('/kfreporting/classifiers/collection-streams',
        {state: {origin: '/kfreporting/kfconfiguration/nextreportcycle', wizardStep: 2}});
    } else {
      this.changeWizardStep.emit(this.wizardStep + 1);
    }
  }

  previousStep(): void {
    this.changeWizardStep.emit(this.wizardStep - 1);
  }
}
